import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center flex-shrink-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/icons/wecoin_icon.png",
  alt: "",
  style: {"width":"20px","height":"20px"}
}, null, -1)
const _hoisted_3 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_4 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}
const _hoisted_7 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: {"background":"#fffbd9 0% 0% no-repeat padding-box","border":"1px solid #ffd600","border-radius":"7px","display":"flex","align-items":"center","justify-content":"center","padding":"0px 10px","height":"30px","cursor":"pointer"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toWalletTransactionPage()))
    }, [
      _hoisted_2,
      _createElementVNode("span", {
        class: "ms-3",
        style: _normalizeStyle([{"font-weight":"bold","user-select":"none","font-size":"14px"}, {
          color:
            _ctx.userCreditWallet == 0
              ? '#575655'
              : _ctx.userCreditWallet < 0
              ? '#f44336'
              : 'green',
        }])
      }, _toDisplayString(Math.floor(_ctx.userCreditWallet * 100) / 100) + " CREDIT", 5)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _ctx.userImage,
          alt: "avatar"
        }, null, 8, _hoisted_5)
      ]),
      _createVNode(_component_KTUserMenu)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/text/txt001.svg" })
        ])
      ])
    ])
  ]))
}